module.exports = __webpack_public_path__ + "img/pic-3-2.f76d7b8a.png";